var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4309_21911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.7188C18.4721 23.7188 23.7188 18.4721 23.7188 12C23.7188 5.52791 18.4721 0.28125 12 0.28125C5.52791 0.28125 0.28125 5.52791 0.28125 12C0.28125 18.4721 5.52791 23.7188 12 23.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1741 19C10.7586 19 10.1078 18.8255 9.02648 18.2434C8.08962 17.739 7.28193 17.0639 6.84958 16.095C5.30041 12.6242 5.77104 7.43324 9.08169 5.70811C10.7628 4.83225 13.4294 4.73601 15.1374 5.60429C16.7756 6.43718 17.5683 7.73658 18.224 9.40374L16.8856 9.78611C16.2675 7.54064 14.7783 6.2966 12.3609 6.2966C11.4056 6.2966 10.5387 6.39257 9.81021 6.75374C8.06759 7.6172 7.35353 9.64278 7.2833 11.6945C7.23222 13.1854 7.47318 14.6904 8.1385 15.7732C8.89952 17.0116 10.4809 17.7948 11.9633 17.7948C13.3518 17.7948 14.469 17.5534 15.3307 16.7452C16.5041 15.6443 16.7486 13.8889 15.2529 12.8186C14.7922 16.7507 9.4602 16.5264 9.4602 13.4011C9.4602 12.7521 9.71259 12.1858 10.2172 11.7022C11.2195 10.7418 12.7275 11.0256 13.9852 11.0066C13.8526 10.413 13.3479 9.553 12.3793 9.553C11.6328 9.553 10.9897 9.74067 10.6439 10.3187L9.60202 9.64277C10.0433 8.81415 10.9331 8.26999 12.2982 8.26999C13.6632 8.26999 14.9995 9.1632 15.2211 10.8571L15.2895 11.3802C16.0611 11.6915 16.6166 12.2723 17.0022 12.8575C18.0866 14.5029 17.4887 16.6135 15.9402 17.9257C15.0954 18.6417 13.8397 18.9999 12.1742 18.9999L12.1741 19ZM10.7042 13.3746C10.7042 14.0185 11.3873 14.5 12.0487 14.5C12.7864 14.5 13.2937 14.2919 13.5703 13.8758C13.8469 13.4597 13.9853 12.9585 13.9853 12.3725C13.2274 12.1799 11.9089 12.0418 11.2101 12.5043C10.881 12.7221 10.7044 12.9996 10.7044 13.3746H10.7042Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4309_21911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.20eee92026af06c4e2e2a0d709e254cb.svg";
export { ForwardRef as ReactComponent };